<template>
    <div>
        <label style="font-size: 0.9em;">{{ label }}</label>
        <div class="container-fluid" style="padding: 0;">
            <div class="row">
                <div class="col">
                    <ui-datepicker :start-of-week="1" placeholder="Any" v-model="selected.from" label="Start" :picker-type="pickerType"
                            :custom-formatter="dateFormatter" @input="emitInput" append-dropdown-to-body></ui-datepicker>
                </div>
                <div class="col">
                    <ui-datepicker :start-of-week="1" placeholder="Any" v-model="selected.to" label="End" :picker-type="pickerType"
                            :custom-formatter="dateFormatter" @input="emitInput" append-dropdown-to-body></ui-datepicker>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Moment from 'moment';

    export default {
        created() {
            if (this.value !== '%') {
                this.selected = this.parseDate(this.value);
            } else {
                this.selected = {
                    from: null,
                    to: null,
                }
            }
        },
        props: {
            pickerType: {
                type: String,
                default() {
                    return 'popover';
                }
            },
            value: {
                type: String,
                default() {
                    return '';
                }
            },
            label: {
                type: String,
                default: 'Dates Between'
            }
        },
        watch: {
            value(newVal, oldVal) {
                if (newVal !== oldVal && newVal.length > 0) {
                    this.selected = this.parseDate(newVal);
                } else {
                    this.selected = {
                        from: null,
                        to: null,
                    }
                }
            }
        },
        data() {
            return {
                selected: {
                    from: null,
                    to: null,
                }
            }
        },
        methods: {
            emitInput() {
                if (this.selected.from && this.selected.to) {
                    let string = [
                        new Moment(this.selected.from).hour(0).minute(0).second(0).format(),
                        new Moment(this.selected.to).hour(23).minute(59).second(59).format()
                    ].join('::');

                    this.$emit('input', string)
                    this.$emit('change', string)
                }
            },
            parseDate(str) {
                let values = str.split('::');

                if (values.length !== 2 || values[0].length < 1 || values[1].length < 1) {
                    return {
                        from: null,
                        to: null,
                    }
                }

                return {
                    from: (new Moment(values[0])).tz('UTC').toDate(),
                    to: (new Moment(values[1])).tz('UTC').toDate(),
                };
            },
            dateFormatter(date) {
                return (new Moment(date)).format('DD/MM/YYYY')
            },
        },
    }
</script>